import Warning from '@mui/icons-material/Warning';
import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Persistent banner shown on MyCases and Case pages when the user has no
 * active subscription. Styled to match needs_review warnings.
 * Hidden for disabled accounts (LawAppBar shows that status instead).
 */
export default function SubscriptionRequiredBanner() {
    const { user } = useAuth();

    if (user?.accountDisabled === true) {
        return null;
    }

    const message = user?.usedFreeTrial
        ? 'Select a plan to continue using AttorneyAide.'
        : 'Select a plan to continue your free trial.';

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.75,
                marginBottom: '16px',
                padding: '10px 14px',
                borderRadius: '4px',
                backgroundColor: 'rgba(244, 67, 54, 0.05)',
                border: '1px solid rgba(244, 67, 54, 0.2)',
                transition: 'all 0.2s ease'
            }}
        >
            <Warning
                sx={{
                    color: 'var(--error-color)',
                    fontSize: '18px',
                    flexShrink: 0,
                }}
            />
            <Typography
                sx={{
                    color: 'var(--error-color)',
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    lineHeight: 1.4,
                }}
            >
                {message}{' '}
                <Link
                    component={RouterLink}
                    to="/account"
                    sx={{
                        fontWeight: 700,
                        textDecoration: 'underline',
                        '&:hover': {
                            opacity: 0.85,
                        },
                    }}
                >
                    Select Now
                </Link>
            </Typography>
        </Box>
    );
}
